import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 13,
	viewBox: "0 0 18 13",
	fill: "#0578BE",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 2.28125C0 1.51263 0.6348 0.875 1.4 0.875H16.6C17.3652 0.875 18 1.51263 18 2.28125V10.7188C18 11.4874 17.3652 12.125 16.6 12.125H1.4C0.6348 12.125 0 11.4874 0 10.7188V2.28125ZM0.72 2.08036H2.7323L8.7116 7.29925C8.82738 7.40024 9.17262 7.40024 9.28839 7.29925L15.2677 2.08036H17.28L9.28839 9.05564C9.17262 9.15663 8.82738 9.15663 8.7116 9.05564L0.72 2.08036Z"
	})]
});
const ForwardRef = forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
